module.exports = __webpack_public_path__ + "static/intro-closed-e69168867f24457dac5e47d789b53dc5.mp4";